var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-send-message" }, [
    _vm.files.length != 0
      ? _c("div", { staticClass: "discussion-preview-div" }, [
          _c(
            "ul",
            { staticClass: "discussion-preview" },
            _vm._l(_vm.files, function (item, key) {
              return _c(
                "li",
                {
                  key: key,
                  on: {
                    click: function ($event) {
                      return _vm.clearInputFile(item.url)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-solid fa-circle-xmark" }),
                  _c("img", {
                    staticClass: "discussion-preview-image",
                    attrs: { src: item.url },
                  }),
                ]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _c("div", { attrs: { id: "send" } }, [
      _c("div", { staticClass: "footer-form-send" }, [
        _c("div", { staticClass: "left" }, [
          _vm.activeMedia
            ? _c("label", { staticClass: "upload-file" }, [
                _c("i", { staticClass: "fa-regular fa-paperclip" }),
                _c("input", {
                  ref: "inputFiles",
                  staticClass: "inputfile form-control",
                  attrs: {
                    hidden: "",
                    type: "file",
                    id: "attachment",
                    name: "attachment",
                    accept: _vm.acceptTypeMedia,
                  },
                  on: { change: _vm.addPreviewFiles },
                }),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "emoji-trigger",
              class: { triggered: _vm.showEmojiPicker },
              on: {
                click: function ($event) {
                  return _vm.toggleEmojiPicker()
                },
              },
            },
            [
              _c("picker", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showEmojiPicker,
                    expression: "showEmojiPicker",
                  },
                ],
                attrs: {
                  data: _vm.emojiIndex,
                  title: "Pick your emoji...",
                  emoji: "point_up",
                },
                on: { select: _vm.addEmoji },
              }),
              _c("i", { staticClass: "fa-regular fa-face-smile" }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "middle" }, [
          _c("div", { staticClass: "container-textarea" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.message,
                  expression: "message",
                },
              ],
              ref: "inputmessage",
              attrs: { id: "textmessage", height: "80px", width: "100%" },
              domProps: { value: _vm.message },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.message = $event.target.value
                  },
                  function ($event) {
                    return _vm.resize()
                  },
                ],
              },
            }),
          ]),
        ]),
        _c("div", { staticClass: "right" }, [
          _c("i", {
            staticClass: "fa-regular fa-paper-plane-top",
            on: { click: _vm.onSubmitMessage },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }